import React from 'react';
import './svg.css';

const GreenCircleIcon = () => {
  return (
    <svg width="50" height="51" viewBox="0 0 50 51" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M49.95 25.4937C49.95 39.2732 38.7795 50.4437 25 50.4437C11.2205 50.4437 0.0500183 39.2732 0.0500183 25.4937C0.0500183 11.7142 11.2205 0.543747 25 0.543747C38.7795 0.543747 49.95 11.7142 49.95 25.4937ZM12.3272 25.0646C13.0302 24.3616 14.1698 24.3616 14.8728 25.0646L20.5095 30.7013L34.7836 16.4272C35.4865 15.7243 36.6262 15.7243 37.3292 16.4272C38.0321 17.1301 38.0321 18.2698 37.3292 18.9728L21.7823 34.5197C21.0793 35.2226 19.9397 35.2226 19.2367 34.5197L12.3272 27.6102C11.6243 26.9072 11.6243 25.7675 12.3272 25.0646Z" fill="#428600" />
    </svg>
  )
}

export default GreenCircleIcon;